import { BaseAPI } from '../api/_constant';

/**
 * Prepends the base URL (without /api) to an image path if it's not already a full URL.
 * 
 * @param {string|null|undefined} imagePath - The image path from the API
 * @returns {string} - The full image URL or empty string if imagePath is falsy
 * 
 * @example
 * getImageUrl('/media/products/image.jpg') // Returns: 'http://localhost:8989/media/products/image.jpg'
 * getImageUrl('https://example.com/image.jpg') // Returns: 'https://example.com/image.jpg' (unchanged)
 * getImageUrl(null) // Returns: ''
 */
const getImageUrl = (imagePath) => {
	// Return empty string if imagePath is falsy
	if (!imagePath) {
		return '';
	}

	// If the image path is already a full URL (starts with http:// or https://), return it as is
	if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
		return imagePath;
	}

	// Get base URL and remove /api from it for images
	// BaseAPI is like 'http://localhost:8989/api/', we want 'http://localhost:8989/'
	const baseUrl = BaseAPI.replace(/\/api\/?$/, '/');
	
	// Remove leading slash if present to avoid double slashes
	const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;

	// Prepend base URL (without /api)
	return `${baseUrl}${cleanPath}`;
};

export default getImageUrl;
